/** @module csi/table/ExcelForSwitchboard */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action",
	"csi/locale",
	"csi/table/Excel",
	"csi/widget/MessageDialog"
], function(declare,_,csiAction,locale,Excel,MessageDialog) {

	return declare(Excel, {
		/** @property {number} _nSwitchboardIndex - index of url in switchboard being processed */
		_nSwitchboardIndex: 0,
		
		/** @property {string[]} _switchboardUrls - list of urls in switchboard to iterate through if there are more than 1; if only 1, then behave like regular Excel */
		_switchboardUrls: null,

		/** @property {string} _urlInitial - root url for initial view if iterating through multiple switchboard items */
		_urlInitial: null,

		/**
		 * Return target type of switchboard for confirmation message
		 * @return {string[]}
		 */
		getStringParameters: function() {
			return [locale.typePlural(this.widget.getViewNode().$Type)];
		},
		
		/**
		 * Only confirm if more than 1 item in switchboard
		 * @return {boolean}
		 */
		hasToConfirmAction: function() {
			return !!this._switchboardUrls;
		},
		
		/**
		 * Process next switchboard item if not displaying last one
		 */
		publish: function() {
			var urls = this._switchboardUrls;
			var index = ++this._nSwitchboardIndex;
			var n = urls && urls.length;
			
			if (n && (index < n)) {
				this._reset();
				this.displayProgressValue(index / n);
				this.process();
			} else {
				this.inherited(arguments);
			}
		},

		/**
		 * Query for switchboard items
		 */
		_preAction: function() {
			var self = this;
			var view = this.widget;
			var plugin = view.getSwitchboard();
			
			this._urlInitial = view.urlRoot;

			return this.when(plugin.store.query(), function(results) {
				if (results.length > 1) {
					self._bRedrawn = true;
					self._switchboardUrls = _.pluck(results, plugin.store.idProperty);
					
					// if multiple items, then switchboard will report progress differently
					self.progressTopic = null;
				}
			});
		},
		
		/**
		 * Output header containing current switchboard item before outputting table
		 */
		_processHierarchy: function() {
			var	node = this.widget.getViewNode();
			if (node) {
				this._excelOutput += '<div>&#160;</div>';
				this._excelOutput += '<div style="font-weight:bold; font-size: 12pt;">' + node.$Name + '</div>';
			}

			this.inherited(arguments);
		},

		/**
		 * Load current item in switchboard
		 */
		_processLoad: function() {
			var view = this.widget;
			var urls = this._switchboardUrls;
			if (urls) {
				var index = this._nSwitchboardIndex;
				var url = urls[index];

				// redraw view to show next switchboard item unless view already loaded for first item
				if (index || (url != this._urlInitial)) {
					return this.m_cache.getNodeDeferred(url)
						.then(function(node) {
							view.setViewNode(node);
							return view.refreshWidget();
						});
				}
			}

			return this.inherited(arguments);
		},

		/**
		 * Redraw view for initial switchboard item
		 */
		_redraw: function() {
			var view = this.widget;

			if (this._urlInitial && (this._urlInitial != view.urlRoot)) {
				// reset to initial switchboard item and refresh view
				view.setViewNode(this.m_cache.get(this._urlInitial));
				view.refreshWidget();
			} else {
				this.inherited(arguments);
			}
		}
	});
});